
const SettlementsIcon = () => {
  return ( 
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <path d="M22.5 11.0857V12.0057C22.4988 14.1621 21.8005 16.2604 20.5093 17.9875C19.2182 19.7147 17.4033 20.9782 15.3354 21.5896C13.2674 22.201 11.0573 22.1276 9.03447 21.3803C7.01168 20.633 5.28465 19.2518 4.11096 17.4428C2.93727 15.6338 2.37979 13.4938 2.52168 11.342C2.66356 9.19029 3.49721 7.14205 4.89828 5.5028C6.29935 3.86354 8.19279 2.72111 10.2962 2.24587C12.3996 1.77063 14.6003 1.98806 16.57 2.86572M22.5 4L12.5 14.01L9.5 11.01" stroke="#0083F6" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
   );
}
 
export default SettlementsIcon;